/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BILLING_PERIOD = "ANNUAL" | "MONTH" | "QUARTER" | "%future added value";
export type TrialEndCreateCustomerInternalInput = {|
  companyId?: ?number,
  token?: ?string,
  billingYearly?: ?boolean,
  billingPeriod?: ?$ReadOnlyArray<?BILLING_PERIOD>,
  invoiceEmail?: ?string,
  contactPhone?: ?string,
  cardHolderName?: ?string,
  seats?: ?number,
  virtualSeats?: ?number,
  withOnboarding?: ?boolean,
  coupon?: ?string,
  selectedPlan?: ?string,
  planId?: ?string,
  virtualUserId?: ?string,
  onboardingId?: ?string,
  term?: ?string,
  changedSeatPrice?: ?number,
  changedVirtualSeatPrice?: ?number,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type trialEndCreateCustomerInternalMutationVariables = {|
  input: TrialEndCreateCustomerInternalInput
|};
export type trialEndCreateCustomerInternalMutationResponse = {|
  +trialEndCreateCustomerInternal: ?{|
    +errors: ?$ReadOnlyArray<?string>
  |}
|};
export type trialEndCreateCustomerInternalMutation = {|
  variables: trialEndCreateCustomerInternalMutationVariables,
  response: trialEndCreateCustomerInternalMutationResponse,
|};
*/


/*
mutation trialEndCreateCustomerInternalMutation(
  $input: TrialEndCreateCustomerInternalInput!
) {
  trialEndCreateCustomerInternal(input: $input) {
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "TrialEndCreateCustomerInternalInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrialEndCreateCustomerInternalPayload",
    "kind": "LinkedField",
    "name": "trialEndCreateCustomerInternal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "trialEndCreateCustomerInternalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "trialEndCreateCustomerInternalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "trialEndCreateCustomerInternalMutation",
    "operationKind": "mutation",
    "text": "mutation trialEndCreateCustomerInternalMutation(\n  $input: TrialEndCreateCustomerInternalInput!\n) {\n  trialEndCreateCustomerInternal(input: $input) {\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a5076247bee6ef0ed0858920f2f0e653';

module.exports = node;
